import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative col-span-1 h-full" }

import { useStore } from '@/store';

export default /*@__PURE__*/_defineComponent({
  __name: 'PanelSidebar',
  setup(__props) {

const store = useStore();
const routes = [
    {
        name: 'Home',
        path: '/',
    },
    {
        name: 'Simple Scale',
        path: '/simple-scale',
    },
    {
        name: 'Continuous Intervals',
        path: '/continuous-intervals',
    },
    {
        name: 'Discrete Intervals',
        path: '/discrete-intervals',
    },
    {
        name: 'Arpeggio',
        path: '/arpeggio',
    },
    {
        name: 'Rhythm',
        path: '/rhythm',
    },
    {
        name: 'Rhythm Detector',
        path: '/rhythm/detector',
    },
    {
        name: 'About',
        path: '/about',
    },
    ...process.env.VUE_APP_MODE != 'development' ? [] : [
        {
            name: 'test',
            path: '/test',
        },
        {
            name: 'earTraining',
            path: 'ear-training'
        }
    ],
]


return (_ctx: any,_cache: any) => {
  const _component_va_sidebar_item_title = _resolveComponent("va-sidebar-item-title")!
  const _component_va_sidebar_item_content = _resolveComponent("va-sidebar-item-content")!
  const _component_va_sidebar_item = _resolveComponent("va-sidebar-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VaSidebar = _resolveComponent("VaSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VaSidebar, {
      modelValue: _unref(store).state.ui.showSidebar,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.ui.showSidebar) = $event)),
      color: "color1",
      gradient: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routes, (item, index) => {
          return _createVNode(_component_router_link, {
            key: index,
            to: item.path
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_sidebar_item, { class: "cursor-pointer" }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_sidebar_item_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_sidebar_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["to"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})